import Link from 'next/link'
import styled from 'styled-components'

export const ContentWrapper = styled.nav`
  background: white;
  padding: 0 25px;
  width: 100%;
  box-sizing: border-box;
  height: 80px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid var(--grey-25);

  & > a {
    text-decoration: none;
    color: black;
    font-size: 18px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    height: 68px;
  }
`

export const TopbarContainer = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 4;
`
export const BodySpacer = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
`
export const Icons = styled.div`
  margin-left: 20px;
  align-items: center;
  display: flex;

  svg {
    width: 24px;
    height: 24px;
  }

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`
export const DesktopLogo = styled.div<{ showOnMobile?: boolean }>`
  display: block;

  ${({ showOnMobile }) =>
    !showOnMobile &&
    `
    @media (max-width: 1200px) {
      display: none;
    }
  `}
`

export const MobileLogo = styled.div`
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`

export const CartIcon = styled.div`
  position: relative;
`

export const Total = styled.div`
  position: absolute;
  top: -1px;
  right: -4px;
  width: 14px;
  height: 14px;
  background: var(--sale);
  text-align: center;
  color: white;
  font-size: 11px;
  font-weight: var(--font-bold);
  line-height: 15px;
  border-radius: 50%;

  @media (max-width: 768px) {
    top: -4px;
    right: -7px;
  }
`
